module.exports = __webpack_public_path__ + "media/promo/panasonic/images/machine-d-d6568568fd06d145b4ff08a26dfd5e12.png";